const BACKUP_URL = 'https://ottoboni.fi.cloudplatform.fi/helpers/currentdate/CurrentDate.php';

export const getDate = () =>
  fetch(document.location)
  .then(response => {
    if (response.headers.has('Date')) {
      return response.headers.get('Date');
    }

    // Resort to Ottoboni date helper as a backup-plan
    return fetch(BACKUP_URL)
      .then(response => response.text())
      .then(text => text);
  });



// WEBPACK FOOTER //
// ./src/api/dateAPI.js